"use client";

import { FaRegStar, FaStar } from "react-icons/fa";

const Rating = ({
  currentValue,
  setCurrentValue,
  hoverValue,
  setHoverValue,
}) => {
  const stars = Array(5).fill(0);

  const handleClick = (value) => {
    setCurrentValue(value);
  };

  const handleMouseOver = (newHoverValue) => {
    setHoverValue(newHoverValue);
  };

  const handleMouseLeave = () => {
    setHoverValue(undefined);
  };

  return (
    <div className="flex items-center">
      {stars.map((_, index) => {
        return (
          <>
            {currentValue === 0 ? (
              <FaRegStar
                key={index}
                size={20}
                onClick={() => handleClick(index + 1)}
                onMouseOver={() => handleMouseOver(index + 1)}
                onMouseLeave={handleMouseLeave}
                onDoubleClick={() => {
                  handleClick(0);
                  handleMouseOver(0);
                }}
                color={
                  (hoverValue || currentValue) > index ? "#FBAE17" : "#ccc"
                }
                className="mr-1 cursor-pointer"
              />
            ) : (
              <FaStar
                key={index}
                size={20}
                onClick={() => handleClick(index + 1)}
                onMouseOver={() => handleMouseOver(index + 1)}
                onMouseLeave={handleMouseLeave}
                onDoubleClick={() => {
                  handleClick(0);
                  handleMouseOver(0);
                }}
                color={
                  (hoverValue || currentValue) > index ? "#FBAE17" : "#ccc"
                }
                className="mr-1 cursor-pointer"
              />
            )}
          </>
        );
      })}
    </div>
  );
};

export default Rating;
